import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const KlaviyoPage = () => (
  <Layout>
    <Seo
      title="Adding your feed to Klaviyo"
      description="Step-by-step instructions for syncing your Upfeed product feed with Klaviyo to use product recommendations in email and SMS flows."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to Klaviyo</Pagetitle>
          <p>
            Follow these steps to sync your UpFeed product feed with Klaviyo so
            you can use up-to-date product data in your email and SMS flows,
            including browse abandonment, back-in-stock, and product
            recommendation emails.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>A Klaviyo account connected to your store.</li>
            </ul>
          </div>

          <h2>Connecting your product catalog to Klaviyo</h2>
          <ul>
            <li>
              In Klaviyo, navigate to 'Catalog' in the left sidebar (under the
              Content section).
            </li>
            <li>Click 'Add a new feed' or 'Connect a product feed'.</li>
            <li>Paste your product feed URL from the app.</li>
            <li>
              If prompted, set the feed format to 'CSV' and the update schedule
              to 'Daily'.
            </li>
            <li>
              Click 'Save' — Klaviyo will automatically sync your product
              catalog on a daily schedule.
            </li>
          </ul>

          <h2>Using your catalog in flows</h2>
          <p>
            Once your catalog is synced you can reference products in your email
            and SMS flows using Klaviyo's product block and dynamic variables.
            This powers flows like browse abandonment, product recommendations,
            back-in-stock alerts, and post-purchase upsells with live product
            data.
          </p>

          <RelatedPlatforms currentSlug="klaviyo" />
        </div>
      </div>
    </div>
  </Layout>
)

export default KlaviyoPage
